import { render, staticRenderFns } from "./CountDownComponent.vue?vue&type=template&id=497652f4&scoped=true&"
import script from "./CountDownComponent.vue?vue&type=script&lang=ts&"
export * from "./CountDownComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CountDownComponent.vue?vue&type=style&index=0&id=497652f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497652f4",
  null
  
)

export default component.exports